<script setup lang="ts">
import { truncate } from '~/utils/filters'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { to } from '~/routing'

import Token from '~/ui/Token.vue'

interface Props {
  tags: string[]
  showMore?: boolean
  truncateSize?: number
  limit?: number
  labelClasses?: string
  detailRoute?: string
}

const props = withDefaults(defineProps<Props>(), {
  showMore: true,
  truncateSize: 25,
  limit: 5,
  labelClasses: '',
  detailRoute: 'library.tags.detail'
})

const { t } = useI18n()
const honorLimit = ref(true)

const tags = computed(() =>
  honorLimit.value
    ?  props.tags.slice(0, props.limit)
    : props.tags
)
</script>

<template>
  <span>
      <Token
      v-for="tag in tags"
      :key="tag"
      v-bind="to({name: props.detailRoute, params: { id: tag } })"
      >
          {{ `#${truncate(tag, props.truncateSize)}` }}
      </Token>

      <Token
        v-if="props.showMore && tags.length < props.tags.length"
        @click.prevent="honorLimit = false"
      >
        {{ t('components.tags.List.button.more', props.tags.length - tags.length) }}
      </Token>
  </span>
</template>
